import { Helmet } from 'react-helmet-async';

interface SchemaMarkupProps {
  customSchema?: Record<string, unknown>;
}

const SchemaMarkup = ({ customSchema }: SchemaMarkupProps) => {
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "FinancialService",
    "@id": "https://atralend.com/#organization",
    "name": "Atralend",
    "alternateName": "Atralend Mortgage Brokerage",
    "description": "Professional mortgage brokerage services in Canada offering residential, commercial, and investment property financing solutions.",
    "url": "https://atralend.com",
    "logo": "https://atralend.com/logo.png",
    "image": "https://atralend.com/og-image.jpg",
    "telephone": "+1-416-555-0123",
    "email": "info@atralend.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "123 Bay Street, Suite 500",
      "addressLocality": "Toronto",
      "addressRegion": "ON",
      "postalCode": "M5J 2T3",
      "addressCountry": "CA"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 43.6532,
      "longitude": -79.3832
    },
    "areaServed": [
      {
        "@type": "Country",
        "name": "Canada"
      },
      {
        "@type": "State",
        "name": "Ontario"
      },
      {
        "@type": "City",
        "name": "Toronto"
      },
      {
        "@type": "City",
        "name": "Mississauga"
      },
      {
        "@type": "City",
        "name": "Brampton"
      },
      {
        "@type": "City",
        "name": "Vancouver"
      },
      {
        "@type": "City",
        "name": "Calgary"
      }
    ],
    "serviceType": [
      "Residential Mortgages",
      "Commercial Mortgages",
      "Investment Property Financing",
      "Mortgage Refinancing",
      "Private Lending",
      "A-Lending",
      "B-Lending",
      "First-Time Home Buyer Mortgages"
    ],
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "18:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "10:00",
        "closes": "14:00"
      }
    ],
    "priceRange": "$$",
    "currenciesAccepted": "CAD",
    "paymentAccepted": "Cash, Credit Card, Bank Transfer",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Mortgage Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Free Mortgage Consultation",
            "description": "Complimentary assessment of your mortgage needs and options"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Mortgage Pre-Approval",
            "description": "Get pre-approved for a mortgage with rate hold protection"
          }
        }
      ]
    },
    "sameAs": [
      "https://www.facebook.com/atralend",
      "https://www.linkedin.com/company/atralend",
      "https://www.instagram.com/atralend",
      "https://twitter.com/atralend"
    ],
    "founder": {
      "@type": "Person",
      "name": "Johnny Kulwartian",
      "jobTitle": "Mortgage Agent",
      "description": "Licensed mortgage broker with over 15 years of experience in Canadian mortgage industry"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "247",
      "bestRating": "5",
      "worstRating": "1"
    }
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Atralend",
    "url": "https://atralend.com",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://atralend.com/blog?search={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://atralend.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Services",
        "item": "https://atralend.com/services"
      }
    ]
  };

  return (
    <Helmet>
      {customSchema && (
        <script type="application/ld+json">
          {JSON.stringify(customSchema)}
        </script>
      )}
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
    </Helmet>
  );
};

export default SchemaMarkup;
